import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { all, shift } from '@/api/client';
export default {
  name: 'Index',
  data: function data() {
    return {
      listData: []
    };
  },
  computed: {
    language: function language() {
      return this.$store.getters.language ? this.$store.getters.language : 0;
    },
    clientId: function clientId() {
      return this.$store.getters.clientId;
    },
    clientName: function clientName() {
      return this.$store.getters.clientName;
    }
  },
  created: function created() {
    //this.getListData()
  },
  methods: {
    getListData: function getListData() {
      var _this = this;
      new Promise(function (resolve, reject) {
        all().then(function (response) {
          // console.log(response)
          if (response.data.code !== '0') {
            _this.$notify({
              title: _this.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          _this.listData = response.data.data;
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleShift: function handleShift(id) {
      var _this2 = this;
      new Promise(function (resolve, reject) {
        shift(id).then(function (response) {
          //console.log(response)
          if (response.data.code === '0') {
            _this2.$store.dispatch('tableDataDictionary/clearTableDataDictionary');
            _this2.$store.dispatch('codeDataDictionary/clearCodeDataDictionary');
            _this2.$store.dispatch('user/setNewToken', response.data.data.token).then(function () {
              _this2.$store.dispatch('user/getInfo').then(function () {
                _this2.$notify({
                  title: _this2.$t('notification.success.title'),
                  message: _this2.$t('notification.success.body'),
                  type: 'success',
                  duration: 3000
                });
                var randomNum = Math.round(Math.random() * 10000);
                _this2.$router.push('/?' + randomNum);
              }).catch(function (error) {
                console.log(error);
              });
            });
          } else {
            _this2.$notify({
              title: _this2.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    loadDataDictionary: function () {
      var _loadDataDictionary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('tableDataDictionary/getTableDataDictionary', lang).then(function () {
                console.log('Load tableDataDictionary success');
              }).catch(function () {
                console.log('Load tableDataDictionary failed');
              });
            case 2:
              _context.next = 4;
              return this.$store.dispatch('codeDataDictionary/getCodeDataDictionary', lang).then(function () {
                console.log('Load codeDataDictionary success');
              }).catch(function () {
                console.log('Load codeDataDictionary failed');
              });
            case 4:
              return _context.abrupt("return", true);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadDataDictionary(_x) {
        return _loadDataDictionary.apply(this, arguments);
      }
      return loadDataDictionary;
    }()
  }
};